import { render } from "./FormWish.vue?vue&type=template&id=39eb9a1a"
import script from "./FormWish.vue?vue&type=script&lang=js"
export * from "./FormWish.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__